import { ChallengeTable } from './ChallengeTable';

export default ChallengeTable;
